import React from "react";

import {
  PHOTO_CATEGORY_TITLES,
  fetchReviewPhotoUrl,
  type ReviewPhoto,
} from "@/api/receiving";
import { PhotoLightbox } from "@/components/PhotoLightbox";

/**
 * Галерея журнала приёмки: общий `PhotoLightbox` с картинками
 * `/receiving-review/photos/{id}`, подписью по категории фото и именем файла
 * «категория · заказ N (номер).jpg».
 */
export function Lightbox({
  photos,
  index,
  orderNumber,
  onNavigate,
  onClose,
}: {
  photos: ReviewPhoto[];
  index: number;
  /** Номер заказа — для имени скачиваемого файла. */
  orderNumber?: string;
  onNavigate: (index: number) => void;
  onClose: () => void;
}): React.ReactElement | null {
  const titleOf = (p: ReviewPhoto) => PHOTO_CATEGORY_TITLES[p.category] ?? p.category;
  return (
    <PhotoLightbox
      photos={photos}
      index={index}
      loadUrl={(p) => fetchReviewPhotoUrl(p.id)}
      title={titleOf}
      fileName={(p, i) =>
        `${titleOf(p)}${orderNumber ? ` · заказ ${orderNumber}` : ""} (${i + 1}).jpg`
      }
      onNavigate={onNavigate}
      onClose={onClose}
    />
  );
}
